export default __webpack_public_path__ + "static/media/bestseller5.4f20bd0d.png";